import Vue from 'vue';

export default Vue.directive('columns-resizable', {
  inserted(el: any) {
    setTimeout(() => {
      let columnWidths: number[] = [];

      const initializeResize = () => {
        if (!el) return;

        let nodeName = el.nodeName;
        if (['TABLE', 'THEAD'].indexOf(nodeName) < 0) {
          const table = el.querySelector('table');
          if (!table) return;
          el = table;
          nodeName = 'TABLE';
        }

        const nodeIsTable = nodeName === 'TABLE';
        const table = nodeIsTable ? el : el.parentElement;
        if (!table) return;

        const thead = table.querySelector('thead');
        if (!thead) return;

        const ths = thead.querySelectorAll('th');
        const barHeight = nodeIsTable ? table.offsetHeight : thead.offsetHeight;

        if (table && table.parentElement) {
          // Guardar los anchos actuales de las columnas antes de reiniciar el plugin
          columnWidths = Array.from(ths).map((th: any, index) => columnWidths[index] || th.offsetWidth);

          // Eliminar contenedores de resize anteriores para evitar duplicados
          const existingResizeContainer = table.parentElement.querySelector('.vue-columns-resizable');
          if (existingResizeContainer) {
            existingResizeContainer.remove();
          }

          const resizeContainer = document.createElement('div');
          table.style.position = 'relative';
          resizeContainer.style.position = 'relative';
          resizeContainer.style.width = table.offsetWidth + 'px';
          resizeContainer.className = "vue-columns-resizable";
          table.parentElement.insertBefore(resizeContainer, table);

          let moving = false;
          let movingIndex = 0;

          ths.forEach((th, index) => {
            // Aplicar los anchos almacenados a cada columna
            th.style.width = columnWidths[index] + 'px';

            if (index + 1 >= ths.length) return;

            const nextTh = ths[index + 1];
            const bar: any = document.createElement('div');

            bar.style.position = 'absolute';
            bar.style.left = nextTh.offsetLeft - 4 + 'px';
            bar.style.top = 0;
            bar.style.height = barHeight + 'px';
            bar.style.width = '8px';
            bar.style.cursor = 'col-resize';
            bar.style.zIndex = 9;
            bar.className = 'columns-resize-bar';

            bar.addEventListener('mouseover', () => {
              bar.style.background = 'rgba(0,0,0,0.5)';
            });
            bar.addEventListener('mouseout', () => {
              bar.style.background = '';
            });
            bar.addEventListener('mousedown', () => {
              moving = true;
              movingIndex = index;
              document.body.style.cursor = 'col-resize';
              document.body.style.userSelect = 'none';
            });

            resizeContainer.appendChild(bar);
          });

          const bars = resizeContainer.querySelectorAll('.columns-resize-bar');

          document.addEventListener('mouseup', () => {
            if (!moving) return;

            moving = false;
            document.body.style.cursor = '';
            document.body.style.userSelect = '';

            bars.forEach((bar: any, index) => {
              bar.style.background = '';
              const th = ths[index];
              const nextTh = ths[index + 1];
              th.style.width = th.offsetWidth + 'px';
              bar.style.left = nextTh.offsetLeft - 4 + 'px';
            });
          });

          const cutPx = (str) => +str.replace('px', '');

          const handleResize = (e) => {
            if (moving) {
              const th = ths[movingIndex];
              const nextTh = ths[movingIndex + 1];
              const bar: any = bars[movingIndex];
              th.style.width = cutPx(th.style.width) + e.movementX + 'px';
              nextTh.style.width = cutPx(nextTh.style.width) - e.movementX + 'px';
              bar.style.left = nextTh.offsetLeft - 4 + e.movementX + 'px';

              // Actualizar los anchos almacenados de las columnas
              columnWidths[movingIndex] = cutPx(th.style.width);
              columnWidths[movingIndex + 1] = cutPx(nextTh.style.width);
            }
          };

          resizeContainer.addEventListener('mousemove', handleResize);
          table.addEventListener('mousemove', handleResize);
        }
      };

      // Llamar a la función de inicialización una vez al montar la directiva
      initializeResize();

      // Crear un MutationObserver para observar cambios en el DOM
      const observer = new MutationObserver(() => {
        // Reinicializar el plugin si hay cambios en el DOM
        initializeResize();
      });

      // Configurar el observador para observar cambios en los hijos de la tabla y en sus atributos
      observer.observe(el, {
        childList: true,
        subtree: true,
        attributes: true,
      });

      // Guardar el observador para desconectarlo en `unbind`
      el._observer = observer;
    }, 0);
  },
  unbind(el: any) {
    // Desconectar el observer cuando la directiva se quite
    if (el._observer) {
      el._observer.disconnect();
      delete el._observer;
    }
  }
});
